import { render, staticRenderFns } from "./EmployeesPage_mobile.vue?vue&type=template&id=55f5c60e&scoped=true"
import script from "./EmployeesPage_mobile.vue?vue&type=script&lang=js"
export * from "./EmployeesPage_mobile.vue?vue&type=script&lang=js"
import style0 from "./EmployeesPage_mobile.vue?vue&type=style&index=0&id=55f5c60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5c60e",
  null
  
)

export default component.exports